import "core-js/modules/es.array.reduce.js";
import React from "react";
import { Link } from "gatsby";
var AuthorNames = function AuthorNames(_ref) {
    var authors = _ref.authors, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$link = _ref.link, link = _ref$link === void 0 ? true : _ref$link, _ref$isMagazine = _ref.isMagazine, isMagazine = _ref$isMagazine === void 0 ? false : _ref$isMagazine;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, authors.reduce(function (acc, author, index) {
        var name = author.name;
        var count = authors.length;
        if (index === count - 1 && index !== 0) {
            acc.push(/*#__PURE__*/ React.createElement("span", {
                key: count + index
            }, " und "));
        }
        else if (index !== 0) {
            acc.push(/*#__PURE__*/ React.createElement("span", {
                key: count + index
            }, ", "));
        }
        if (link) {
            acc.push(/*#__PURE__*/ React.createElement(Link, {
                key: index,
                to: "/autoren/" + author.slug + "/artikel/",
                className: "hover:underline"
            }, name));
        }
        else {
            acc.push(/*#__PURE__*/ React.createElement("span", {
                key: index
            }, name));
        }
        return acc;
    }, isMagazine ? [/*#__PURE__*/ React.createElement("span", {
            key: -1
        }, "Mit Beitr\xE4gen von ")] : [/*#__PURE__*/ React.createElement("span", {
            key: -1
        }, "Von ")]));
};
export default AuthorNames;
